<template>
	<div class="invoice">
		<div class="row section-header">
			<div class="col-xs-12"><h1 class="title">{{ invoice.title }}</h1></div>
		</div>
		<div class="row section-subheader">
			<div class="col-xs-8 billing-info">
				<p><b>Kepada Yth:</b></p>
				<div v-html="companyInfo"></div>
				<div v-html="companyContact"></div>
			</div>
			<div class="col-xs-4 sidebar-header view-min-width">
				<table class="table table-narrow-padding">
					<tbody>
						<tr>
							<th>Tanggal Mulai</th>
							<td>: {{ displayDate(invoice.start_date) }}</td>
						</tr>
						<tr>
							<th>Tanggal Berakhir</th>
							<td>: {{ isDate(invoice.end_date) }}</td>
						</tr>
						<tr id="total">
							<th>Total</th>
							<td>: {{ formatPrice(invoice.grandtotal) }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="row section-body">
			<div class="col-xs-12">
				<table class="table items-detail">
					<thead>
						<tr>
							<th width="45%">ITEM</th>
							<th width="10%">QTY</th>
							<th width="20%">PRICE</th>
							<th class="text-right" width="25%">AMOUNT</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in invoice.details" :key="item.id">
							<td>
								<b>{{item.name}}</b> <br />
								<p v-html="item.description" style="white-space: pre-line;"></p>
								<p v-for="subitem in item.subservices" :key="subitem.id">
									<b>{{subitem.name}}</b> <br/>
									<span v-html="subitem.description"></span>
								</p>
							</td>
							<td>{{ item.qty }}</td>
							<td>{{ formatPrice(item.price) }}</td>
							<td class="text-right">{{ formatPrice(item.subtotal) }}</td>
						</tr>
						<tr class="noborder">
							<td colspan="2" rowspan="5">
								<h4 class="note-title">Note:</h4>
								<p>{{ invoice.note }}</p>
							</td>
						</tr>
						<tr class="noborder">
							<td>
								Subtotal
							</td>
							<td class="text-right">{{ formatPrice(invoice.total) }}</td>
						</tr>
						<tr class="noborder">
							<td>
								Discount
							</td>
							<td class="text-right">{{ formatPrice(invoice.discount) }}</td>
						</tr>
						<!-- <tr class="noborder">
							<td>
								Payment
							</td>
							<td class="text-right">{{ formatPrice(invoice.payment) }}</td>
						</tr> -->
						<tr class="noborder">
							<td>
								Grand Total
							</td>
							<td class="text-right">{{ formatPrice(invoice.grandtotal) }}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<p style="page-break-before: always">
			<div class="col-xs-12">
				<div class="col-xs-12"><h2 class="payment-term-title">Payment Term</h2></div>
				<div class="col-xs-12">
					<table class="table table-bordered payment-term-table">
						<thead>
							<tr>
								<th>Description</th>
								<th width="75px">(%)</th>
								<th width="30%" class="text-right">Amount</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="payment in invoice.payment_terms" :key="payment.id">
								<td>{{payment.description}}</td>
								<td>{{payment.percentage}}%</td>
								<td class="text-right">{{paymentTermAmount(payment.percentage)}}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="col-xs-12">
				<div class="col-xs-12">
					<h2 class="payment-term-title">Account No</h2>
					<p>We accept only wire transfer to this following account.</p>
					<div class="col-xs-12" v-html="accountNo"></div>
				</div>
			</div>
			<div class="col-xs-12">
				<div class="col-xs-12"><h2 class="payment-term-conditions">Term & Conditions</h2></div>
				<div class="col-xs-12">
					<p v-html="invoice.terms"></p>
				</div>
			</div>
			<DocumentFooterPrintable />
		</div>
	</div>
</template>

<script>
import { formatPrice, displayDate } from '../../helpers';
import DocumentFooterPrintable from "../DocumentFooterPrintable.vue";
export default {
	components: { DocumentFooterPrintable },
	props: {
		invoice: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			isLoading: false,
			accountNo: ""
		}
	},
	async beforeMount() {
		try {
			const settingResp = await axios.get(`/settings`);
			this.accountNo = settingResp.data.data.settings.bank_account;
		} catch {
			this.$notify({
				type: 'error',
				title: 'Oops!',
				text: 'Sorry, an error occured!'
			})
		}
	},
	computed: {
		companyInfo() {
			return '<p>' + this.invoice.customer.name + '<br />' + this.invoice.customer.company.name + '<br />' 
						+ (this.invoice.customer.company.address ? this.invoice.customer.company.address : "") + '</p>' 
		},
		companyContact() {
			return '<p>' + (this.invoice.customer.phone ? this.invoice.customer.phone : "") + '<br />' + (this.invoice.customer.email ? this.invoice.customer.email : "") + '</p>';
		},
	},
	methods: {
		formatPrice, displayDate,
		paymentTermAmount(percentage) {
			let grandTotal = parseFloat(this.invoice.total) - parseFloat(this.invoice.discount);
			return formatPrice(parseFloat(grandTotal) * parseFloat(percentage) / 100);
		},
		isDate(date) {
			return (date && !isNaN(new Date(date)) ) ? displayDate(date) : '-';
		},
	}
}
</script>
